import { Schema, arrayOf, normalize } from 'normalizr';
import _ from 'lodash';

const featureSchema = new Schema('features', {
  idAttribute: f => f.id,
  assignEntity: (output, key, value) => {
    if (key === 'featureId') {
      output.id = value;

      if ('featureId' in output) {
        delete output.featureId;
      }
    } else {
      output[key] = value;
    }
  }
});

const fabricatorSchema = new Schema('fabricators');

fabricatorSchema.define({
  features: arrayOf(featureSchema)
});

const orderedBySchema = new Schema('orderedBy');

orderedBySchema.define({
  features: arrayOf(featureSchema),
  fabricators: arrayOf(fabricatorSchema)
});

// Merge a feature that is defined by the FeatureDefinition model with a feature defined by the FabricatorFeature
// model. The FeatureDefinition model is missing a few fields defined on the FabricatorFeature model, and the
// FabricatorFeature model has the correct values for some of the equivalent fields in the FeatureDefinition model.
function mergeFeatureEntites(A, B, entityKey) {
  for (const key in B) {
    if (!B.hasOwnProperty(key)) {
      continue;
    }

    if (!A.hasOwnProperty(key) || _.isEqual(A[key], B[key])) {
      A[key] = B[key];
      continue;
    }

    if (entityKey !== 'features') {
      continue;
    }

    if (key.indexOf('fabricatorCost') !== -1) {
      // Take any field with 'fabricatorCost' in its name from B if A's value is null.
      if (!A[key]) {
        A[key] = B[key];
        continue;
      }
    }

    if (key.indexOf('hide') !== -1) {
      // Take any field with 'hide' in its name from B, after converting it from a string to a boolean value.
      const value = B[key];

      A[key] = typeof value === 'string' ? (value.toLowerCase() === 'true') : value;
      continue;
    }
  }
}

function getValue(value, def_value) {
  if(typeof value !== 'undefined' && value != '') {
    return value;
  }
  return def_value;
}

export const normalizeQuoteModel = function(obj, options = {}) {
  const {fabricators, features} = obj;
  var normalized = normalize({ id: 'root', fabricators, features, ...obj }, orderedBySchema, { ...options, mergeIntoEntity: mergeFeatureEntites });
  _.each(normalized.entities.features, (feature) => {
    var fabFeat = _.find(fabricators[0].features, (feat) => {
      return feat.featureId == feature.id
    });

    feature.fabricatorFeatureId = fabFeat.id;
    feature.isEnabled = fabFeat.enabled;
    feature.name = getValue(fabFeat.name, feature.name);
    feature.cost = getValue(fabFeat.cost, feature.cost);
    feature.costPlus = getValue(fabFeat.costPlus, feature.costPlus);
    feature.hideFromFrontEnd = getValue(fabFeat.hideFromFrontEnd, feature.hideFromFrontEnd);
    feature.fabricatorBaseQuantity = getValue(fabFeat.fabricatorBaseQuantity, feature.fabricatorBaseQuantity);
    feature.fabricatorComparisonFor = getValue(fabFeat.fabricatorComparisonFor, feature.fabricatorComparisonFor);
    feature.fabricatorCost = getValue(fabFeat.fabricatorCost, feature.fabricatorCost);
    feature.fabricatorCostPlus = getValue(fabFeat.fabricatorCostPlus, feature.fabricatorCostPlus);
    feature.fabricatorMaxQuantity = getValue(fabFeat.fabricatorMaxQuantity, feature.fabricatorMaxQuantity);
    feature.description = getValue(fabFeat.description, feature.description);
    feature.selectedUnit = getValue(fabFeat.unit, feature.unit);
    feature.hideFromKitchenVisualizer = getValue(fabFeat.hideFromKitchenVisualizer, feature.hideFromKitchenVisualizer);
  });
  return normalized;
}